<template>
	<component
		@click="onClick"
		scroll
		:is="tag"
		class="Button"
		:type="type"
		:size="size"
		:to="to"
		:href="to"
	>
		<slot></slot>
	</component>
</template>

<script>
const TYPES = [
	"blue",
	"blue-transparent",
	"grey",
	"grey-transparent",
	"transparent",
	"blue-light",
	"primary",
	"gradient-primary",
	"gradient-blue",
	"gradient-green",
	"black",
	"black-transparent",
	"black-bordered",
	"attachment"
];
const SIZES = ["default", "large", "medium", "small"];

export default {
	name: "BasicButton",
	props: {
		tag: {
			type: String,
			default: "a"
		},
		type: {
			type: String,
			default: "blue",
			validator(value) {
				return TYPES.indexOf(value) >= 0;
			}
		},
		size: {
			type: String,
			default: "default",
			validator(value) {
				return SIZES.indexOf(value) >= 0;
			}
		},
		to: [String, Object]
	},
	methods: {
		onClick(e) {
			if (scroll) {
				this.scrollTo = "body";
			}

			this.$emit("click", e);
		}
	}
};
</script>

<style scoped lang="scss" type="text/scss">
@import "../assets/scss/globals";
@import "../assets/scss/mixins";

span.Button {
	cursor: default;
}

.Button {
	display: inline-block;
	text-align: center;
	text-transform: capitalize;
	cursor: pointer;
	font-family: $font-paragraphs;
	font-size: 1rem;
	text-decoration: none;
	border-radius: 6em;
	border: 2px solid;
	padding: 0 1.25em;
	color: white;
	background-color: $blue;
	outline: none;
	transition-property: color, background-color, background-position,
		border-color;
	transition-duration: 0.2s;
	transition-timing-function: ease-in-out;

	&:hover {
		background-color: $dull-lavender;
	}

	&[size="default"] {
		font-size: 16px;
		min-width: 193px;
		height: 45px;
		line-height: 41px; // 45 - border-width * 2
	}

	&[size="large"] {
		font-size: 18px;
		width: em(257, 18);
		height: em(52, 18);
		line-height: em(48, 18); // 52 - border-width * 2
	}

	/*&[size="large"] {*/
	/*font-size: 18px;*/
	/*width: 257px;*/
	/*height: 52px;*/
	/*line-height: 48px; // 52 - border-width * 2*/
	/*}*/

	&[size="medium"] {
		font-size: 14px;
		min-width: 141px;
		height: 37px;
		line-height: 33px; // 37 - border-width * 2
	}

	&[size="small"] {
		font-size: 12px;
		min-width: 93px;
		height: 31px;
		line-height: 27px; // 31 - border-width * 2
		padding: 0 17px;
	}

	&[type^="gradient-"] {
		&[size="large"] {
			line-height: em(52, 18);
		}

		&[size="default"] {
			line-height: 45px;
		}

		&[size="medium"] {
			line-height: 37px;
		}

		&[size="small"] {
			line-height: 31px;
		}
	}

	/* Button types */
	&[type="blue"] {
		background-color: $text-blue;
		border-color: $text-blue;
		color: #fff;
	}

	&[type="blue-light"] {
		border-color: #d7d7d7;
		color: black;
		font-size: 12px;
		font-weight: 400;
		background-color: #d7d7d7;
		padding: 3px 20px;
		height: 38px;
		&:hover {
			background-color: #d7d7d7;
		}
	}

	&[type="blue-transparent"] {
		background-color: transparent;
		border-color: $blue;
		color: $blue;

		&:hover {
			background-color: $dull-lavender;
			border-color: $dull-lavender;
		}
	}

	&[type="grey"] {
		background-color: $mine-shaft;
		border-color: $mine-shaft;
		color: white;

		&:hover {
			background-color: grey;
			border-color: grey;
		}
	}

	&[type="grey-transparent"] {
		background-color: transparent;
		color: $text-weak;
		border-color: $text-weak;

		&:hover {
			background-color: $text-weak;
			border-color: $text-weak;
			color: white;
		}
	}

	&[type="transparent"] {
		background-color: transparent;
		border-color: transparent;
		color: $blue;
		&:active {
			background-color: transparent !important;
			border-color: transparent !important;
		}
		&:focus {
			background-color: transparent !important;
			border-color: transparent !important;
		}
		&:hover {
			color: $dull-lavender;
		}
	}

	&[type="primary"] {
		background-color: $primary;
		border-color: $primary;
		color: white;

		&:hover {
			background-color: darken($primary, 10%);
			border-color: darken($primary, 10%);
		}
	}

	&[type^="gradient-"] {
		border: 0;
		color: #fff;
	}

	&[type="gradient-primary"] {
		background-image: linear-gradient(270deg, #f44d52 0%, #fbb03b 100%);
	}

	&[type="gradient-blue"] {
		background-image: linear-gradient(270deg, #6e3acb 0%, #00b5f2 100%);
	}

	&[type="gradient-green"] {
		background-image: linear-gradient(270deg, #00ba88 0%, #f9c900 100%);
	}

	&[type="black"] {
		background-color: black;
		color: white;
		border-color: black;

		&:hover {
			background-color: $mine-shaft;
			border-color: $mine-shaft;
			color: white;
		}
	}

	&[type="black-transparent"] {
		background-color: transparent;
		border-color: transparent;
		color: black;

		&:hover {
			color: $mine-shaft;
		}
	}
	&[type="black-bordered"] {
		background-color: transparent;
		border: 3px solid black;
		color: black;

		&:hover {
			background-color: black;
			color: #fff;
		}
	}

	&[type="attachment"] {
		background-color: black;
		border-color: black;
		color: white;
		border-radius: 0px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/BasicButton.vue